
// export const baseUrl = process.env.REACT_APP_LMS_BASE_URL;
export const baseUrl = process.env.REACT_APP_ASSET_BASE_URL;
export const keycloakbaseurl = process.env.REACT_APP_URM_BASE_URL;
export const appserveraddr = process.env.REACT_APP_APP_SERVER_ADDRESS;
export const urmservice = process.env.REACT_APP_URM_SERVICE;
export const serviceBaseURL = process.env.REACT_APP_DATA_SERVICE;
export const dataservice = process.env.REACT_APP_DATA_SERVICE;
export const gisserviceBaseURL = process.env.REACT_APP_GIS_SERVICE;
export const dmscoreservicecontextname =
  process.env.REACT_APP_CORE_CONTEXT_PATH_NAME;
export const userMgmtService = process.env.REACT_APP_DATA_SERVICE;

//user image...
export const getUserImage = "/auth/media/file/";
export const postImage = "/user_profile/change_picture";
export const uploadProfilePic = "/user/uploadProfilePic"; // POST form-data: file → { status, msg, attachments_path, id }
export const authUserData = "/user_profile/getUserProfile";
export const changePassword = "/auth/profile/change_password";
export const updateUserData = "/user_profile/update";

//User Management
export const createRole = "/role/create";
export const updateRole = "/role/update";
export const deleteRole = "/role/delete";
export const getAllRole = "/role/getAllRolesByAppType";
export const getAllRoleByTrue = "/role/getAllRolesWithAdminTrueByAppType"
export const getAllActiveRole = "/role/getallActiveRoles";
export const deletePermissionsFromRole = "/role/deletePermissionsFromRole/";
export const findPermissionsByUser = "/role/findPermissionsByUser";
export const findRolesByUser = "/role/findRolesByUser";

export const getallUsersByRealm = "/urm/admin/realms/{REALM}/users";
export const getAdminAuthTokenByRealm =
  "/urm/realms/{REALM}/protocol/openid-connect/token";
export const createUserintoRealm = "/urm/admin/realms/{REALM}/users";
export const getallRolesByRealm = "/urm/admin/realms/{REALM}/roles";
export const addPermissionsToRole = "/role/addPermissionsToRole/";
export const createRoleintoRealm = "/urm/admin/realms/{REALM}/roles";

export const getRoleDataByRoleNameURL = "/urm/admin/realms/{REALM}/roles/";
export const getUserDataByEmailAttr =
  "/urm/admin/realms/{REALM}/users?email={EMAIL}&exact=true";
export const assignRolesToUser =
  "/urm/admin/realms/{REALM}/users/{USER_ID}/role-mappings/realm";
export const deleteUserByRealm = "/urm/admin/realms/{REALM}/users/{USER_ID}";
export const userImageUpload = "/user";
export const mediaFileLink = "/media/file";
export const findUsersById = "/user/findUsersById";
// export const userListByRole = "/user/getUsersByLoginId?user_id=268&role_type=SUPER_ADMIN&bank_id=null";
export const userListByRole = "/user/getUsersByLoginId?user_id=USERID&role_type=ROLETYPE&bank_id=BANKID";
export const departmentslist = "/department/getall";
export const grievanceDepartmentslist = "/department/getallGrievanceDepartments";

// ---------------------------------------------------------------------------------

//User Management
export const updateUserStatusByUserId =
  "/urm/admin/realms/{REALM}/users/{USER_ID}";
export const getUserByUserId = "/urm/admin/realms/{REALM}/users/";
export const getRoleById = "/urm/admin/realms/{REALM}/roles-by-id/";
export const getRolesByUserId =
  "/urm/admin/realms/{REALM}/users/{USER_ID}/role-mappings";
export const updateUserByUserId = "/urm/admin/realms/{REALM}/users/";
export const deletRoleById = "/urm/admin/realms/{REALM}/roles-by-id/";
export const getAllPermissions = "/permission/getall/byAppType";
export const getAllPermissionsMobile = "/permission/getall/mob"
export const getUsersFromApp = "/user/getall";
export const getUsersFromAppByRole = "/user/getAllByRole";   //user/getAllByRole

//Resource Management
export const resourceListURL = "/resource/getall";
export const uniqeResourceListURL = "/resource/getUniqueResourceList";
export const createResourceURL = "/resource/create";
export const updateResourceURL = "/resource/update";
export const deleteResourcebyId = "/resource/delete";
export const findResourcesById = "/resource/findResourcesById";
export const resourceStatusInProgress = "/resource/management/inprogress";
export const resourceStatusClosed = "/resource/management/closed";

export const regionListURL = "/region/getall";
export const minifiedRegionListURL = "/region/getMinifiedRegionList";
export const getChildRegionsById = "/region/findChildrenRegionsById";
export const findRegionsByUser = "/region/findRegionsByUser";
export const getRestrictedRegionListURL = "/region/getRestrictedRegionList";
export const findRegionsInfoById = "/region/findRegionsInfoById";

export const resourceTypListURL = "/config/getConfigsByCategoryName/RSRC_KND";
export const agencyListURL = "/agency/getall";
export const createAgencyURL = "/agency/create";
export const agencyTypeListURL = "/config/getConfigsByCategoryName/AGNCY_TYPE";
export const skillListURL = "/config/getConfigsByCategoryName/SKILL";
export const masterDataAttrTypeListURL =
  "/config/getConfigsByCategoryName/MASTER_DATA_TYPE";
export const getConfigsByCategoryName = "/config/getConfigsByCategoryName/";
export const createConfig = "/config/create";
export const updateConfig = "/config/update";
export const deleteConfig = "/config/delete";
export const hierarchylevelListURL = "/region/getall";
export const createResource = "/resource/create";
export const createRegion = "/region/create";
export const assignRoleToUser = "/user/create";
export const updateUserInAppURL = "/user/update";

//Region Management
export const findRegionById = "/region/findRegionsById";
export const updateRegion = "/region/update";
export const deleteRegionURL = "/region/delete";

//AgencyManagement
export const agencyTypeURL = "/config/getConfigsByCategoryName/AGNC_TYP";
export const findAgenciesById = "/agency/findAgenciesById";
export const updateAgencyURL = "/agency/update";
export const deleteAgencyURL = "/agency/delete";

//ContactManagement
export const createContact = "/contact/create";
export const getContacts = "/contact/getallUserAndContacts";
export const getAllContacts = "/contact/getall";
export const getAllContactsByRole = "/contact/getAllByRole";
export const updateContact = "/contact/update";
export const deleteContactURL = "/contact/delete";
export const getskillTypesURL = "/config/getConfigsByCategoryName/SKILL";
export const deleteUserById = "/user/delete";
//FacilityManagement
export const createFacility = "/facility/create";
export const getFacilities = "/facility/getall";
export const creategisFacilityEntry = "/create/facility";
export const updateFacility = "/facility/update";
export const updategisFacilityEntry = "/update/facility";
export const findFacilityById = "/facility/findFacilitiesById";
export const getFacilityTypeURL = "/config/getConfigsByCategoryName/FCLTY_TYP";
export const deleteFacilityURL = "/facility/delete";
export const deleteCKById = "/api/upsertAPI?api_key=";

//Master Resource Data Management
export const createMasterResource = "/master_resource/create";
export const getMasterResourceListURL = "/master_resource/getall";
export const resourceActivityListURL = "/master_resource/getResourceActivties";
export const resourceCatListURL = "/master_resource/getResourceCategories/";
export const resourceNameListURL = "/master_resource/getResourceNames";
export const getMasterResourceByIdURL =
  "/master_resource/findMasterResourcesById";
export const deleteMasterResourceById = "/master_resource/deleteMasterResource";
export const deleteMasterResourceImageByName = "/master_resource/delete_resource_image";

//Job Title Management
export const createJobTitle = "/job_title/create";
export const getJobTitle = "/config/getConfigsByCategoryName/JOB_TITLE";

//Contact Management
export const findContactsById = "/contact/findContactsById";

//Task Management
export const getTaskConfigsURL = "/config/getConfigsByCategoryNames";
export const createTaskURL = "/task/create";
export const getTaskListURL = "/task/getall";
export const getTaskListURLById = "/task//getAllByIncident?incident_id=ID";
export const updateTaskURL = "/task/update";
export const deleteTaskURL = "/task/delete";
export const findTaskById = "/task/findTasksById";
export const createTaskandAssign = "/assignTasksToUsers";
export const getMatserUserTaskList = "/task/getmasterusertasks";
export const getIncidentData = "/getData/incident";
export const createNewTask = "/task/assignTasksToUsers"
export const getAllincidents = "/getData/getAllincidents";
export const deleteTaskById = "/task/deleteUserTask"
export const getAllIndlTask = "/task/getuserinditask"

//SOP Management
export const createMasterSOPURL = "/sop_master/create";
export const updateMasterSOPURL = "/sop_master/update";
export const getMasterSOPListURL = "/sop_master/getMasterSOPList";
export const getActiveMasterSOPList = "/sop_master/getActiveMasterSOPList";
export const getSOPTasksDtlBySOPId = "/sop_master/getSOPTasksDtlBySOPId/";
export const getSOPRsrcDtlBySOPId = "/sop_master/getSOPRsrcDtlBySOPId/";
export const deleteSopById = "/sop_master/delete";
export const completeNotificationSop = "/task/completeNotificationForSop";
export const sopInstanceList = "/sop/instance/getAllSopInstances"
export const incidentList = "/task/getAllIncidents"
export const sopList = "/sop_master/getAllSOPs"
export const SopTaskTableData = "/sop/instance/getSopTask"
export const sopResourceList = "/sop/instance/getSopResources"
export const sopGetIncident = "/sop/instance/getIncident"
export const SopUserData = "/sop/instance/getUserByRole"
export const CreateSopInstance = "/sop/instance/createSopInstance"
export const getSopMasterData = "/sop/instance/getSopTaskInstance/"
export const CloseSopTask = "/task/closeTask"
export const CancelSopTask = "/task/cancelTask"
export const executeSopContactList = "/sop/instance/getUserByRole";
export const getAllIncidentsByCtegorySop = "/task/getAllIncidentByCategory/"
export const getAllSopByIncident = "/sop_master/getAllSOPsByIncident/"




//My Task Management
export const getMyTaskListURL = "/task/findTasksByUser";
export const getMyIndividualTaskListURL = "/getData/getuserinditask";
export const claimMytask = "/task/claimMyTask";
export const completeMytask = "/task/completeTask";
export const completeNotificationtask = "/completeNotification";
export const completeIndiTask = "/completeUserIndiTask";
export const completeIndivTask = "/task/completeUserIndiTask"
export const completeTask = "/task/completeTask";
export const completeNotificationTypeTask = "/task/completeNotification"
export const claimIndTask = "/task/claimMyTaskDailyOperations"

//For Builder
export const createFormStructure = "/formbuilder/create";
export const getFormStructureURL = "/formbuilder/view";
export const gtFormDataByFormNameURL =
  "/formbuilderdata/getFormdataByFormName/";
export const getStoredFormTemplates = "/formbuilder/getStoredFormTemplates";

//For Builder Data
export const createFormDataViaBuilder = "/formbuilderdata/create";

//Dashboard URLS
export const getBlockInfoFloodURL =
  "/dailyfloodreport/getBlockInfoFrFlood?to_date=TODATE&dist_id=DISTID&api_key=APIKEY&from_date=FROMDATE";
export const getAnimalShelterListURL = "/facility_report/getASTabularReport";
export const getCKListURL = "/facility_report/getCKTabularReport";
export const getMealsDetailsURL = "/facility_report/getMealDetailsByMealType";
export const getFloodReliefData = "/facility_report/getFLTabularReport";
export const getFacilityReportAttrByReportIdAndCat =
  "/facility_report/getFacilityReportAttrByReportIdAndCat";
export const getDailyReportListURL = "/dailyreport/getDailyReportTabularView";
export const getDailyReportbyId =
  "/dailyreport/getDailyReportbyId?dailyReportId=";
export const getFacilityOpenReport = "/facility_report/getFacilityOpenReport";
export const getFacilityReport = "/facility_report/getFacilityReport";
export const getFacilitySummaryReport =
  "/facility/getFacilitiesSummaryByFacilityTypeId";
export const getASStats = "/facility_report/getASStats";
export const getFloodEntityStats = "/facility_report/getFloodEntityStats";
export const getDailyReportByDistrict =
  "/dailyfloodreport/getDailyReportbyRegionId";
export const getDailyAffectedReportByDistrict =
  "/dailyfloodreportaffected/getDailyReportAffected";
export const getDailyColdWaveReport =
  "/dailycoldwavereport/getDailyColdWaveReport";
export const getDailyPartiallyAffectedReportByDistrict =
  "/dailyfloodreportpartiallyaffected/getDailyReportPartiallyAffected";
export const getDailyReportByState = "/statefloodreport/getDailyStateReport";
export const getAffectedDailyReportByState =
  "/dailyfloodaffectedreport/getDailyFloodAfected";
export const getPartiallyAffectedDailyReportByState =
  "/dailyfloodpareport/getPADailyReportbyRegionId";
export const getStateFloodCountData =
  "/dailyfloodreport/getDasCountDetails?from_date=FROMDATE&to_date=TODATE";
export const getCurrStateFloodCountData =
  "/api/executeAPI?api_key=get_flood_curr_dashboard";
export const getCurrBarChartData = "/api/executeAPI?api_key=";
export const getForm1StatusData = "/api/executeAPI?api_key=get_form1_status";
export const getBlockWiseReport =
  "/dailyfloodreport/getBlockDetails?from_date=FROMDATE&to_date=TODATE";
export const getAffectedBlock =
  "/dailyfloodreport/getAffectedBlockDetails?from_date=FROMDATE&to_date=TODATE";
export const getAffectedDistrict =
  "/dailyfloodreport/getAffectedDistDetails?from_date=FROMDATE&to_date=TODATE";
export const getAffectedNagarNigam =
  "/dailyfloodreport/getAffectedNagarNigamDetails?from_date=FROMDATE&to_date=TODATE";
export const getAffectedPanchayat =
  "/dailyfloodreport/getAffectedGramPanchyatsDetails?from_date=FROMDATE&to_date=TODATE";
export const getAffectedDrilldownView =
  "/dailyfloodreport/API_KEY?from_date=FROMDATE&to_date=TODATE";
export const updateFloodReport = "/dailyfloodreport/update";
export const getDailyFloodReportListURL =
  "/dailyfloodreport/getDailyFloodReport?region_id=ID&reported_on=DATE";
export const cleardailyReportData =
  "/dailyfloodreport/clearFloodReportEntity?report_id=";
//Theme URLS
export const getThemeURL = "/user_profile/getUserProfile";
export const getUserProfileImage = "/user_profile/get_user_image";
export const updateThemeDataURL = "/user_profile/update";

export const getRiverListURL = "/config/getConfigsByCategoryName/RVRS";

//Mis report
export const misReportData =
  "/dailyfloodreport/getMISDistrictFloodReport";

export const misReportDataCumm = "/dailyfloodreport/getMISDistrictFloodReportCumulate";


//Facility Dashboard

export const facilityDashboardData = "/dailyfloodreport/getIncidentFacilitiesDetails";

export const getBMSKData = "/dailyfloodreport/getBmskAPIDetails?from_date=FROMDATE"

// User Log API's

export const createUserLog = "/user/createUserLog";

export const getUserLog = "/user/getUserLog";

// Human Loss API's

export const getHumanLoss = "/humanLoss/getHumanLossList?reported_on=DATE&distName=DISTNAME&type=VIEW";

export const getPoliceStationDetails = "/policeStationMaster/getPoliceStationMasterDetails";

export const getDisasterList = "/disasterMaster/getDisasterMasterDetails";

export const createHumanLossDetails = "/humanLoss/createDetails?reported_on=DATE";

export const updateHumanLossPrimaryDetails = "/humanLoss/updatePrimary?reported_on=DATE"

export const deleteHumanLossDetailedDetail = "/humanLoss/deleteHumanLossDetail/"

export const deleteHumanLossPrimaryDetails = "/humanLoss/deleteHumanLossPrimaryAndDetail/"

export const humanlossdashboardincidentcarddata = "/humanLoss/getIncidentCount?from_date=FROMDATE&to_date=TODATE"

export const humanlossdashboardincidenttabledata = "/humanLoss/getTabularCount?from_date=FROMDATE&to_date=TODATE&disaster=ID"

export const humanlossdashboardincidenttableblocldata = "/humanLoss/getTabularCountByBlock?from_date=FROMDATE&to_date=TODATE&dist_name=DISTNAME&disaster=ID"

export const humanlosstrendchartdata = "/humanLoss/getTrendChartCount?from_date=FROMDATE&to_date=TODATE&id=ID"

export const humanlossdougnutchartdata = "/humanLoss/getIncidentByIdDonutCount?from_date=FROMDATE&to_date=TODATE&disaster=ID"

export const humanlossbarchartdata = "/humanLoss/getBarChartCount?from_date=FROMDATE&to_date=TODATE&id=ID"


//Cold WAVE

export const updateColdWaveDetails = "/dailycoldwavereport/update?reported_on=DATE"

export const deleteColdWaveDetail = "/dailycoldwavereport/delete"

export const misColdWaveReport = "/dailycoldwavereport/getMISReport"

export const getMISColdWaveCum = "/dailycoldwavereport/getMISCumulate"



//Heat Wave

export const getHeatWaveFormatAReport = "/heatwave/getHeatwaveFormA";

export const getHeatWaveFormatCReport = "/heatwave/getHeatwaveFormC";

export const updateHeatWaveFormAReport = "/heatwave/createPrimary?reported_on=DATE";

export const deleteHeatWaveFormA = "/heatwave/deleteFormA";



export const updateHeatWaveFormCReport = "/heatwave/createHospitalInfo?reported_on=DATE";

export const deleteHeatWaveFormC = "/heatwave/deleteFormC";

export const getHeatWaveFormatBReport = "/heatwave/getHeatwaveFormB";
export const updateHeatWaveFormBReport = "/heatwave/createPrimary?reported_on=DATE";
export const deleteHeatWaveFormB = "/heatwave/deleteFormB";
export const misheatwavereporttoday = "/heatwave/getMISReport"
export const misheatwavereportcumm = "/heatwave/getMISCumulate"

//Fire

export const getFireCommunityKitchenReport = "/fire/getCK/UI";
export const updateFireCommunityKitchenForm = "/fire/createCK?reported_on=DATE";
export const deletFireCommunityKitchenReport = "/fire/delete";
export const firedashboardcardsdata = "/fire/getCardsCount?from_date=FROMDATE&to_date=TODATE"
export const firedashboardbarchart = "/fire/getBarChartCount?from_date=FROMDATE&to_date=TODATE&bar_type=BARTYPE"
export const firedashboardblockdata = "/fire/getBarChartCountByBlock"


export const coldwavecardsdata = "/dailycoldwavereport/getCardsCount?from_date=FROMDATE&to_date=TODATE"
export const coldwavechartdata = "/dailycoldwavereport/getBarChartCount?from_date=FROMDATE&to_date=TODATE&bar_type=BARTYPE"

export const coldwavepopupdata = "/dailycoldwavereport/getBarChartCountByBlock"

//Fire Daily Report

export const getFireReportData = "/fire/getDailyReport"

export const updateFireReportData = "/fire/update"

export const delteFireReportData = "/fire/delete/DR/"

export const deleteAddressFieldData = "/fire/delete/address/"



export const getDailyHeatWaveReport = "/heatwave/getForm/UI";
export const updateHeatWaveDetails = "/heatwave/create?reported_on=DATE";
export const deleteHeatWaveDetail = "/heatwave/deleteForm";

export const heatwavecardsdata = "/heatwave/getCardsCount?from_date=FROMDATE&to_date=TODATE"
export const heatwavechartdata = "/heatwave/getBarChartCount?from_date=FROMDATE&to_date=TODATE&bar_type=BARTYPE"
export const heatwavepopupdata = "/heatwave/getBarChartCountByBlock"


//Human Loss MIS

export const getHumanLossMisReport = "/humanLoss/getMISReport";


//Fire incident MIS

export const getFireMisReport = "/fire/getMISReport";

export const getFirMisReportCum = "/fire/getMISCumulate";

//Branch
export const createBranch = "/branch/create";
export const getallBanks = "/bank/getall";
export const getallBanksByRole = "/bank/getAllByRole";

// create alert cat/subcate

export const getcategories = '/branch/announcements/getAllCategories';
export const getsubcategories = '/branch/announcements/getAllSubCategories?categoryName=NAME'
export const getbarches = '/branch/getAllBranches?bankId=ID'
export const alertsaveapi = '/branch/announcements/create'
export const getcategoryalldata = '/branch/announcements/getAllCategoryBySubCategories'
export const getBranchListData = "/branch/getall"

export const getDistrictByBranches = "/branch/getDistrictByBranches"
export const getDistrictByBranchesByRole = "/branch/getDistrictByBranchesByRole"
export const getAllBankBranchList = "/branch/getAllBankWithBranches"
export const getAllBankBranchListByRole = "/branch/getAllBankWithBranchesByRole"

//Branch
// export const createBranch = "/branch/create";
// export const getallBanks = "/bank/getall";
export const getallbranchnames = "/branch/getAllBranches?bankId=ID";
//Bank api's
export const createBankDetails = "/bank/create";

export const createincident = "/branch/incident/create";
export const getAllIncidentsData = "/branch/incident/getall/";
export const deleteIncidentByID = "/branch/incident/delete/";
export const editIncidentdata = "/branch/incident/update";
export const usersByDepartment = "/branch/incident/getUserByDepartment";
export const createEvent = "/event/create";
export const fetchAllIncidentsByRole = "/branch/incident/getall";

// export const getallBanks = "/bank/getall";

export const saveatmdetails = "/ATM/create"
export const getatmalldetails = "/ATM/getall"
export const getatmalldetailsByRole = "/ATM/getAllByRole"

// Event
export const getAllEventType = "/config/getConfigsBySubCategoryName/INCDNT_SUB_CAT/";
export const getAllRolesByUsers = "/sop/instance/getUserByRole/";
export const editEventInprogress = "/event/inprogress";
export const editEventClosed = "/event/closed";
export const getincidents = "/branch/incident/getIncidents/";

export const getEventsdata = "/event/getEventsByIncident?incidentId=ID&createdBy=UID";
export const getEventsdataByIncident = "/event/getEventsByIncident";

//distic wise atm service

export const getdistricwisedata = "/ATM/getDistrictByATM"
export const getdistricwisedataByRole = "/ATM/getDistrictByAtmByRole"
export const updateAtm = "/ATM/update"
export const deleteAtm = "/ATM/delete"

export const updateBankDetails = "/bank/update";

export const rolebaseuser = "/sop/instance/getUserByRole/ID"
export const Allassetcategory = "/config/getConfigsByCategoryNames"
export const getassetsubcategory = "/config/getConfigsBySubCategoryName/ASSET_SUB_CAT/ID"
export const stafftype = "/config/getConfigsByCategoryNames"
export const saveapires = "/resource/management/create"
export const updateresource = "/resource/management/update"
export const getallresources = "/resource/management/getall/"
export const getallresourcesByRole = "/resource/management/getAllResourcesByRole"
export const getGisData = "/branch/incident/getAllBranchesAndATMsAndIncidents";

export const gisCoordinatesData = "/incident/getDistrictMap/";
export const gisStateCoordinates = "/incident/getStateMap/";
export const updateBranchDetails = "/branch/update";
export const districtsInGis = "/region/getAllRegions?region_type=District";
export const gisBlockCoordinatesData = "/incident/getBlockMap/";

//Grievance apis

export const getIssueType = "/config/getConfigsByCategoryNames";
export const getSubIssueType = "/config/getConfigsBySubCategoryName/GRV_SUB_CAT_TYPE/ID";

export const getResMethods = "/config/getConfigsByCategoryNames";

export const createGrievance = "/grievance/create";

export const fetchGrievanceData = "/grievance/getall/";

export const grievanceInprogress = "/grievance/inprogress";
export const grievanceResolved = "/grievance/resolved";
export const grievanceClosed = "/grievance/closed";
export const grievanceRejected = "/grievance/reject";
export const grievanceOpen = "/grievance/open";
export const grievanceAccept = "/grievance/accept";
export const commentingForAdmins = "/grievance/commentsMap"
export const acceptAfterEsclation = "/grievance/accept"
export const reopenAfterClosed = "/grievance/reopenTicket"
export const manualEscalateL1 = "/grievance/manualProcessEscalateToL1";
export const manualEscalateL2 = "/grievance/manualProcessEscalateToL2";
export const manualEscalateL3 = "/grievance/manualProcessEscalateToL3";

// Dynamic Dashboards
export const tableList = "/config/getTableNames";
export const ColumnsByTable = "/config/getColumnNames/";
export const getQueriesList = "/service-metadata/getAll";
export const getApiQueriesList = "/service-metadata-api/getAll";
export const createDashboard = "/dashboard-layouts/createOrUpdate";
export const getAllDashboards = "/dashboard-layouts/getAll";
export const deleteDashboards = "/dashboard-layouts/delete";
export const getDasboardsByUserId = "/dashboard-layouts/getUserById"
export const statusUpdate = "/dashboard-layouts/statusUpdate"
export const getblocksfromdistid = "/region/findAllChildrenRegionsById";
export const getLayoutsByRole = "/dashboard-layouts/getAllLayouts";
export const getAllLayoutsByRole = "/dashboard-layouts/getAllLayoutsByRoles";
export const getUserlistByBranchId = "/user/getUsersByBranch?branch_id=BRANCHID";
export const getUserlistByBank = "/user/getUsersByBank?bank_id=BANKID";
export const getInstanceUrl = "/instance/url/getInstanceUrl";
export const getAllurls = "/api/getall";
export const getAllColumns = "/api/columns/getall";
export const getexternalApi = "/nifi/external-api";
export const fetchVehicleTracking = "/vehicle-data/fetchVehicleTracking";
export const fetchVehicleTrackingWithIdealPoints = "/vehicle-data/fetchVehicleTrackingWithIdealPoints";
export const tableListFilltered = "/datasource/getTableNames";
export const getQueriesListByWidgetType = "/service-metadata/getAllByWidgetType?widgetType=WIDGETTYPE";





export const getBankAndBranchLogo = "/bank/getBankLogo";
export const getAllDistricts = "/region/getAllDistricts";
export const findAllChildrenRegionsById = "/region/findAllChildrenRegionsById";
export const findAllGeofenceChildrenRegionsById = "/region/findAllGeofenceChildrenRegionsById";


export const getVehicleDataForTracking = "/vehicle-tracking/fetchData";
export const getRegionByRole = "/region/getallByAppType";     ///region/getAllByRole

export const getroutname = "/vehicleExpected/pathNames"
export const getroutlatlon = "/vehicleExpected/ID/waypoints"
export const getAssignedWaypoints = "/vehicleExpected/ID/assigned-waypoints"

export const createroutefleet = "/vehicleExpected/create"
export const getvehicles = "/vehicleExpected/vehicles"
export const createassignroute = "/vehicle-route-assignment/create"

export const getvehiclefiler = "/vehicle-route-assignment/filter?vehicleNumber=ID&startDate=ID1&endDate=ID2"
export const getAccidentDetails = "/vehicle-tracking/getById/ID"
export const getAccidentsHistory = "/accident-history/getAll"
export const accknowladgeAccidentId = "/accident-history/resolve/ID"

//Create vehicle apis
export const createVehicle  = "/vehicleinfo/create"
export const getAllVehicles  = "/vehicleinfo/getall"
export const getVehicleById           = "/vehicleinfo/getById"
export const getVehicleByNumber       = "/vehicleinfo/getByVehicleNumber"
export const updateVehicle  = "/vehicleinfo/update"
export const deleteVehicle  = "/vehicleinfo/delete"

//Fleet user management apis (TODO: confirm paths with backend)
export const createFleetUser  = "/user/createV2" // multipart: userData (JSON text) + files + licenseFile
export const getAllFleetUsers = "/user/getallByAppType"
export const updateFleetUser  = "/user/updateV2"
export const deleteFleetUser  = "/user/deleteV2"



export const getQueriesListByWidgetTypeForAPI = "/service-metadata-api/getAllByWidgetType?widgetType=WIDGETTYPE";
export const createDashboardForApi = "/dashboard-layouts/api/createOrUpdate";
export const deleteDashboardsForApi = "/dashboard-layouts/api/delete";
export const statusUpdateForApi = "/dashboard-layouts/api/statusUpdate";
export const getAllLayoutsByRoleForApi = "/dashboard-layouts/api/getAllLayoutsByRoles";

export const plannedsubmitapi = "/vehicle-route-assignment/getPlaneedRoutes"

// export const departmentslist = "/department/getall";


export const validateUserNames = "/user/validateUserName?user_name=USERNAME";
export const updateplannedroute = "/vehicle-route-assignment/updatePlannedRoute";
export const travelstarttripapi = "/vehicle-travel-route/create"
export const travelendtripapi = "/vehicle-travel-route/update?vehicleNumber=VNO&routeId=RID&assignedRouteId=assignid&endDate=ENDDate"
export const getalltriplist = "/vehicle-travel-route/getAllPlannedRoutes"


//Manage SLA
export const createSLA = "/SLA/create";
export const updateSLA = "/SLA/update";
export const getAllSLA = "/SLA/getall";
export const deleteSLAById = "/SLA/delete";
// export const validateSLAPriority = "/validatePriorityAssignedToTicket?priority=PRIORITY";

export const getallforuserdet = "/attendance/getAll"
export const getAllPriority = "/SLA/getAllPrioritySLA?priority=PRIORITY";
export const getAllUserNames = "/grievance/getUsersByUserLevel?userLevel=USERLEVEL";
export const getUsersByUserLevelExceptCurrent = "/user/getUsersByUserLevelExceptCurrent?userLevel=L1&userId=USERID"


//Tickets Notification
export const getOpenTicketsCount = "/grievance-notifications/unreadCount"
export const getNotificationsList = "/grievance-notifications/all"
export const getWebSocketEndpoint = "/ws";
export const notificationRead = "/grievance-notifications/markRead/ID"
export const notificationMarkAllRead = "/grievance-notifications/markRead/multiple"
export const getGrievanceData = "/grievance/getall/ID"

export const getDepartmentsCurrent = "/department/getAllDepartmentsExceptCurrent?departmentId=DEPTID"
export const createCrossDepartment = "/cross-department/transfer"


//facerelatedapis
export const createimageface ="/person/create"
export const updateimageface ="/person/update/ID"
export const deleteperson ="/person/delete"
export const getallpersons ="/person/getAll"
export const getAllCameras = "/cameras/getAll"
export const getAllCurrentLiveData = "/cameras/live_count"
export const getAllCameraNotifications = "/cameras/notifications/getAll"
export const getAnalyticsDataByDate = "/cameras/live_count/getByDate"
export const startRecordingLive = "/live-stream/camera/ID/recording/start"
export const stopRecordingLive = "/live-stream/camera/ID/recording/stop/RECORDING_ID"
export const getAllRecordingsByFilters = "/live-stream/camera/recording/filter-by-date?cameraId=CAMERAID&fromDate=FROMDATE&toDate=TODATE"
export const markAllReadCameraNotifications = "/cameras/notifications/mark-read-delete"


export const cancelTrip ="/vehicle-route-assignment/cancel"
export const getAllResons ="/vehicle-route-assignment/getAllResons"
export const deleteRoute ="/vehicleExpected/delete"
export const getRouteDetails = "/vehicleExpected/route-details/ID"
export const getWayPoints = "/vehicleExpected/fetchwaypoints"
export const getVehicleRouteAlertTrackWindow = "/vehicle-route-alerts/track-window/ID"
export const getVehicleRouteAlertTrackWithAlerts = "/vehicle-route-alerts/track-with-alerts"
export const updateRoute = "/vehicleExpected/update/ID"
export const fetchVehicleTrackingWithSummary = "/vehicle-data/fetchVehicleTrackingWithSummary"



export const getlivestatus ='/vehicle-tracking/live-status'
export const creategeofence = '/geofence/create'
export const getgeofences ='/geofence/getAll'
export const geofenceByRoute = '/geofence/by-route/'
export const getgeofencecategories = '/geofence/categories'

export const getgeofenceall ='/geofence/getAllWithVehicles'
export const getalertsall ='/vehicle-geolocation-alerts/getall'
export const ackupdate ='/vehicle-geolocation-alerts/acknowledge'

// OTA Management
export const otaGetDevices          = "/ota/admin/devices";
export const otaGetFirmwares        = "/ota/admin/firmwares";
export const otaGetUpdateHistory    = "/ota/admin/update-history";
export const otaUploadFirmware      = "/ota/admin/upload-firmware";
export const otaRescheduleFirmware  = "/ota/updateScheduleTime/FIRMWARE_ID";
export const otaDeleteByDeviceId    = "/ota/deleteByDeviceId";
export const otaRevertFirmware      = "/ota/admin/rollback/DEVICE_ID";

//assigngeofence
export const getroutlatlonnew = "/vehicleExpected/ID/waypoints-info"
